import axios from "axios";
import { sweetAlert } from "./utilities/sweet-alert";

document.addEventListener("DOMContentLoaded", () => {
	document
		.getElementById("contact-form")
		.addEventListener("submit", (event) => {
            console.log("Button clicked");
			event.preventDefault();

			const form = document.getElementById("contact-form");
			const formData = new FormData(form);
			formData.append("action", "submit_contact_form");
			axios
				.post(ajaxObject.url, formData)
				.then((response) => {
					sweetAlert
						.fire({
							title: "Thank you!",
							text: `We got your information. Someone will contact you soon.`,
							icon: "success",
							confirmButtonText: "Continue",
						})
						.then(() => {
							location.reload();
						});
				})
				.catch((error) => {
					sweetAlert
						.fire({
							title: "Oops!",
							text: "An error occurred while submitting the form. Please try again.",
							icon: "error",
							confirmButtonText: "OK",
						})
						.then(() => {
							location.reload();
						});
				});
		});
});
